module.exports = __webpack_public_path__ + "img/title.07bf899c.png";